// extracted by mini-css-extract-plugin
export default {"listContainer":"PaginatorHorizontal_listContainer__T9XvY"};